export const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return { ...state, loading: action.payload };
    case "SET_SERVICES":
      return { ...state, services: action.payload };
    case "SET_PRODUCTS":
      return { ...state, products: action.payload };
    case "SET_MICROSERVICES":
      return { ...state, microServices: action.payload };
    case "SET_LOGO":
      return { ...state, logo: action.payload };
    case "SET_LOGO_WHITE":
      return { ...state, logoWhite: action.payload };
    default:
      return state;
  }
};
